import { render, staticRenderFns } from "./FactumAppealBookRspToAppealPg.vue?vue&type=template&id=3eb84bff&scoped=true"
import script from "./FactumAppealBookRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./FactumAppealBookRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb84bff",
  null
  
)

export default component.exports